import { useEffect, useState } from "react";
import { Link, NavLink, useLocation } from "react-router-dom";
import { Menu, X, Leaf, Phone } from "lucide-react";
import { companyInfo } from "../mock";

const navItems = [
  { to: "/", label: "Home" },
  { to: "/chi-siamo", label: "Chi siamo" },
  { to: "/servizi", label: "Servizi" },
  { to: "/fotogallery", label: "Fotogallery" },
  { to: "/contatti", label: "Contatti" },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);
  const location = useLocation();
  const isHome = location.pathname === "/";

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener("scroll", onScroll);
    onScroll();
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  useEffect(() => {
    setOpen(false);
  }, [location.pathname]);

  const transparent = isHome && !scrolled;

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-colors duration-500 ${
        transparent
          ? "bg-transparent"
          : "bg-white/95 backdrop-blur-md shadow-[0_1px_0_0_rgba(0,0,0,0.04)]"
      }`}
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-10">
        <div className="flex items-center justify-between h-20">
          <Link to="/" className="flex items-center gap-3 group">
            <div
              className={`w-10 h-10 rounded-full flex items-center justify-center transition-colors ${
                transparent ? "bg-white/20 backdrop-blur" : "bg-sage-100"
              }`}
            >
              <Leaf
                className={`w-5 h-5 ${
                  transparent ? "text-white" : "text-sage-700"
                }`}
                strokeWidth={1.5}
              />
            </div>
            <div className="flex flex-col leading-none">
              <span
                className={`font-serif text-xl tracking-wide ${
                  transparent ? "text-white" : "text-sage-900"
                }`}
              >
                Rota Adriano Battista & C S.a.s.
              </span>
            </div>
          </Link>

          <nav className="hidden lg:flex items-center gap-9">
            {navItems.map((item) => (
              <NavLink
                key={item.to}
                to={item.to}
                end={item.to === "/"}
                className={({ isActive }) =>
                  `link-underline text-sm tracking-wide transition-colors ${
                    transparent
                      ? "text-white/90 hover:text-white"
                      : isActive
                      ? "text-sage-700 font-medium"
                      : "text-sage-900 hover:text-sage-700"
                  }`
                }
              >
                {item.label}
              </NavLink>
            ))}
          </nav>

          <a
            href={`tel:${companyInfo.phone.replace(/\s/g, "")}`}
            className={`hidden lg:inline-flex items-center gap-2 px-5 py-2.5 rounded-full text-sm transition-all duration-300 ${
              transparent
                ? "bg-white text-sage-800 hover:bg-sage-50"
                : "bg-sage-700 text-white hover:bg-sage-800"
            }`}
          >
            <Phone className="w-4 h-4" strokeWidth={1.8} />
            {companyInfo.phone}
          </a>

          <button
            className="lg:hidden p-2"
            onClick={() => setOpen(!open)}
            aria-label="Menu"
          >
            {open ? (
              <X className={transparent ? "text-white" : "text-sage-900"} />
            ) : (
              <Menu className={transparent ? "text-white" : "text-sage-900"} />
            )}
          </button>
        </div>
      </div>

      {/* Mobile Menu */}
      <div
        className={`lg:hidden overflow-hidden transition-all duration-300 bg-white ${
          open ? "max-h-96 border-t border-sage-200" : "max-h-0"
        }`}
      >
        <div className="px-6 py-6 flex flex-col gap-4">
          {navItems.map((item) => (
            <NavLink
              key={item.to}
              to={item.to}
              end={item.to === "/"}
              className={({ isActive }) =>
                `text-base ${
                  isActive ? "text-sage-700 font-medium" : "text-sage-900"
                }`
              }
            >
              {item.label}
            </NavLink>
          ))}
          <a
            href={`tel:${companyInfo.phone.replace(/\s/g, "")}`}
            className="mt-2 inline-flex items-center gap-2 px-5 py-3 rounded-full bg-sage-700 text-white text-sm w-fit"
          >
            <Phone className="w-4 h-4" /> {companyInfo.phone}
          </a>
        </div>
      </div>
    </header>
  );
}
